import type { Rule } from 'antd/es/form';

/**
 * Luật kiểm ở form chỉ để báo lỗi SỚM cho người dùng; máy chủ kiểm lại y hệt và là nơi
 * quyết định (xem `apps/api/src/modules/auth/password.ts`).
 */
export const USERNAME_RULES: Rule[] = [
  { required: true, message: 'Nhập tên đăng nhập' },
  {
    pattern: /^[a-z0-9._-]{3,32}$/,
    message: 'Tên đăng nhập 3-32 ký tự, chỉ chữ thường/số và dấu . _ -',
    transform: (value: unknown) => (typeof value === 'string' ? value.trim().toLowerCase() : value),
  },
];

export const PASSWORD_RULES: Rule[] = [
  { required: true, message: 'Nhập mật khẩu' },
  { min: 8, message: 'Mật khẩu phải từ 8 ký tự trở lên' },
];
